import { useRef, useState, useEffect } from 'react';
import * as Styled from './TextBoxWithTooltip.styled';
import { Tooltip } from 'antd';

interface TextBoxWithTooltipProps {
  text: string;
  backgroundColor?: string;
  backgroundHoverColor?: string;
  className?: string;
}

const TextBoxWithTooltip = ({ text, backgroundColor, backgroundHoverColor, className }: TextBoxWithTooltipProps) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      const isOverflowing = textRef.current.scrollWidth > textRef.current.clientWidth;
      setIsOverflowing(isOverflowing);
    }
  }, [text]);

  return (
    <Tooltip title={isOverflowing ? text : ''}>
      <Styled.Container className={className} ref={textRef} bgColor={backgroundColor} bgHoverColor={backgroundHoverColor}>
        {text}
      </Styled.Container>
    </Tooltip>
  );
};

export default TextBoxWithTooltip;
